import store from '@state/store'

const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/authentication/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        next(
          authRequiredOnPreviousRoute ? { name: 'Dashboard' } : { ...routeFrom }
        )
      },
    },
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: () =>
      lazyLoadView(import('@views/pages/authentication/sign-up')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/confirm-otp',
    name: 'confirm-otp',
    component: () =>
      lazyLoadView(import('@views/pages/authentication/confirm-otp')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () =>
      lazyLoadView(import('@views/pages/authentication/forgot-password')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already chagne password
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-phone-number',
    name: 'confirm-phone-number',
    component: () =>
      lazyLoadView(import('@views/pages/authentication/confirm-phone-number')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already sign in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
]

const TaxRoutes = [
  {
    path: '/tax',
    name: 'Tax',
    component: () => lazyLoadView(import('@views/pages/tax')),
  },
]

const publicVehicleRoutes = [
  {
    path: '/vehicle/:vin',
    name: 'publicVehicle',
    header: 'General',
    hidden: true,
    component: () => lazyLoadView(import('@views/pages/public-vehicle')),
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const errorPagesRoutes = [
  {
    path: '/403',
    name: '403',
    component: require('@views/pages/secondary/error-403').default,
    props: true,
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/pages/secondary/error-404').default,
    props: true,
  },
  {
    path: '/500',
    name: '500',
    component: require('@views/pages/secondary/error-500').default,
    props: true,
  },
  {
    path: '*',
    redirect: '404',
  },
]

const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'uil-home',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const WholesaleRoutes = [
  {
    path: '/wholesale',
    name: 'Wholesale',
    icon: 'uil-car',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/wholesale')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const bannerRoutes = [
  {
    path: '/banner',
    name: 'News',
    icon: 'uil-newspaper',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/banner')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const warehouseRoutes = [
  {
    path: '/warehouse',
    name: 'Warehouse',
    icon: 'uil-home',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/warehouse')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-warehouse',
        component: () => lazyLoadView(import('@views/pages/warehouse')),
      },
      {
        path: 'edit',
        name: 'edit-warehouse',
        component: () => lazyLoadView(import('@views/pages/warehouse')),
      },
    ],
  },
]

const dispatcherRoutes = [
  {
    path: '/dispatcher',
    name: 'Dispatcher',
    icon: 'uil-home',
    component: () => lazyLoadView(import('@views/pages/dispatcher')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-dispatcher',
        component: () => lazyLoadView(import('@views/pages/dispatcher')),
      },
      {
        path: 'edit',
        name: 'edit-dispatcher',
        component: () => lazyLoadView(import('@views/pages/dispatcher')),
      },
    ],
  },
]

const clearenceRoutes = [
  {
    path: '/consignee',
    name: 'Consignee',
    icon: 'uil-home',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/clearance')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-consignee',
        component: () => lazyLoadView(import('@views/pages/clearance')),
      },
      {
        path: 'edit',
        name: 'edit-consignee',
        component: () => lazyLoadView(import('@views/pages/clearance')),
      },
    ],
  },
]

const licensedCompanyRoutes = [
  {
    path: '/licensed-companies',
    name: 'Licensed Company',
    icon: 'uil-home',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/licensed-company')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-licensed-company',
        component: () => lazyLoadView(import('@views/pages/licensed-company')),
      },
      {
        path: 'edit',
        name: 'edit-licensed-company',
        component: () => lazyLoadView(import('@views/pages/licensed-company')),
      },
    ],
  },
]

const auctionRoute = [
  {
    path: '/auction',
    name: 'Auction',
    icon: 'uil-home',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/auction')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-auction',
        component: () => lazyLoadView(import('@views/pages/auction')),
      },
      {
        path: 'edit',
        name: 'edit-auction',
        component: () => lazyLoadView(import('@views/pages/auction')),
      },
    ],
  },
]

const vehiclesRoutes = [
  {
    path: '/vehicles',
    name: 'Vehicles',
    icon: 'uil-car',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/vehicle')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const ownershipRoutes = [
  {
    path: '/ownership',
    name: 'ownerships',
    header: 'General',
    hidden: true,
    component: () => lazyLoadView(import('@views/pages/ownership')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const noteToClientRoutes = [
  {
    path: '/note-to-client',
    name: 'Note To Client',
    header: 'General',
    hidden: true,
    component: () => lazyLoadView(import('@views/pages/note-to-client')),
    meta: { authRequired: true, adminRequired: false },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const userInvoiceRoutes = [
  {
    path: '/user-invoice',
    name: 'User Invoice',
    header: 'General',
    hidden: true,
    component: () => lazyLoadView(import('@views/pages/user-invoice')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const ticketsRoutes = [
  {
    path: '/tickets',
    name: 'Ticket',
    icon: 'uil-ticket',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/ticket')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const usersRoutes = [
  {
    path: '/users',
    name: 'User',
    icon: 'uil-user',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/user')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const autoCheckRoutes = [
  {
    path: '/autocheck',
    name: 'Auto Check',
    icon: 'uil-check-square',
    component: () => lazyLoadView(import('@views/pages/auto-check')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const settingRoutes = [
  {
    path: '/settings',
    name: 'Settings',
    icon: ' uil-cog',
    meta: { authRequired: true, adminRequired: true, renderChildren: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'city',
        name: 'City',
        component: () => lazyLoadView(import('@views/pages/setting/city')),
        meta: { authRequired: true, adminRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'state',
        name: 'State',
        component: () => lazyLoadView(import('@views/pages/setting/state')),
        meta: { authRequired: true, adminRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: '',
        name: 'Auto Check',
        component: () => lazyLoadView(import('@views/pages/setting')),
        meta: { authRequired: true, adminRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'tac',
        name: 'T&C',
        component: () => lazyLoadView(import('@views/pages/setting/option')),
        meta: { authRequired: true, adminRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'vehicle-information',
        name: 'Vehicle Information',
        component: () =>
          lazyLoadView(import('@views/pages/vehicle-information')),
        mata: { authRequired: true, adminRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]

const profileRoutes = [
  {
    path: '/users/:id',
    name: 'prfile',
    icon: 'uil-user',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/profile')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const TariffRoutes = [
  {
    path: '/tariff',
    name: 'Tariff',
    icon: 'uil-usd-circle',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/tariff')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const CarrierRoutes = [
  {
    path: '/carrier',
    name: 'Carrier',
    icon: 'uil-location',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/carrier')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-carrier',
        component: () => lazyLoadView(import('@views/pages/carrier')),
      },
      {
        path: 'edit',
        name: 'edit-carrier',
        component: () => lazyLoadView(import('@views/pages/carrier')),
      },
    ],
  },
]

const BrokerRoutes = [
  {
    path: '/broker',
    name: 'Broker',
    icon: 'uil-user-exclamation',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/broker')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-broker',
        component: () => lazyLoadView(import('@views/pages/broker')),
      },
      {
        path: 'edit',
        name: 'edit-broker',
        component: () => lazyLoadView(import('@views/pages/broker')),
      },
    ],
  },
]

const TemplateRoutes = [
  {
    path: '/template',
    name: 'Template',
    icon: 'uil-user-exclamation',
    header: 'General',
    component: () => lazyLoadView(import('@views/pages/template')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const vesselRoutes = [
  {
    path: '/vessel',
    name: 'Vessel',
    icon: 'uil-ship',
    component: () => lazyLoadView(import('@views/pages/vessel')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-vessel',
        component: () => lazyLoadView(import('@views/pages/vessel')),
      },
      {
        path: 'edit',
        name: 'edit-vessel',
        component: () => lazyLoadView(import('@views/pages/vessel')),
      },
    ],
  },
]

const destinationRoutes = [
  {
    path: '/destination',
    name: 'Destination',
    icon: 'uil-location-point',
    component: () => lazyLoadView(import('@views/pages/destination')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-destination',
        component: () => lazyLoadView(import('@views/pages/destination')),
      },
      {
        path: 'edit',
        name: 'edit-destination',
        component: () => lazyLoadView(import('@views/pages/destination')),
      },
    ],
  },
]

const terminalRoutes = [
  {
    path: '/terminal',
    name: 'Terminal',
    icon: 'uil-building',
    component: () => lazyLoadView(import('@views/pages/terminal')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
    children: [
      {
        path: 'create',
        name: 'create-terminal',
        component: () => lazyLoadView(import('@views/pages/terminal')),
      },
      {
        path: 'edit',
        name: 'edit-terminal',
        component: () => lazyLoadView(import('@views/pages/terminal')),
      },
    ],
  },
]

const portNameRoutes = [
  {
    path: '/port-name',
    name: 'Port Name',
    icon: 'uil-anchor',
    component: () => lazyLoadView(import('@views/pages/port-name')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const coverLetterRoutes = [
  {
    path: '/cover-letter',
    name: 'Cover Letter',
    icon: 'uil-file-alt',
    component: () => lazyLoadView(import('@views/pages/cover-letter')),
    meta: { authRequired: true, adminRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const authProtectedRoutes = [
  ...dashboardRoutes,
  ...vehiclesRoutes,
  ...WholesaleRoutes,
  ...ticketsRoutes,
  ...autoCheckRoutes,
  ...TariffRoutes,
  ...CarrierRoutes,
]

const privateProtectedRoutes = [
  ...dashboardRoutes,
  ...vehiclesRoutes,
  ...WholesaleRoutes,
  ...ticketsRoutes,
  ...autoCheckRoutes,
  ...TariffRoutes,
]

const brokerProtectedRoutes = [...dashboardRoutes, ...vehiclesRoutes]

const endUserProtectedRoutes = [...dashboardRoutes, ...vehiclesRoutes]

const warehouseProtectedRoutes = [...dashboardRoutes, ...vehiclesRoutes]

const financeireProtectedRoutes = [
  ...dashboardRoutes,
  ...vehiclesRoutes,
  ...WholesaleRoutes,
  ...ticketsRoutes,
  ...autoCheckRoutes,
  ...TariffRoutes,
  ...CarrierRoutes,
]

const adminProtectedRoutes = [
  ...dashboardRoutes,
  ...vehiclesRoutes,
  ...WholesaleRoutes,
  ...warehouseRoutes,
  ...TemplateRoutes,
  ...clearenceRoutes,
  ...licensedCompanyRoutes,
  ...auctionRoute,
  ...CarrierRoutes,
  ...ticketsRoutes,
  ...autoCheckRoutes,
  ...usersRoutes,
  ...BrokerRoutes,
  ...bannerRoutes,
  ...settingRoutes,
  ...publicVehicleRoutes,
  ...ownershipRoutes,
  ...noteToClientRoutes,
  ...userInvoiceRoutes,
  ...TariffRoutes,
  ...dispatcherRoutes,
  ...vesselRoutes,
  ...destinationRoutes,
  ...terminalRoutes,
  ...portNameRoutes,
  ...coverLetterRoutes,
]

const allRoutes = [
  ...profileRoutes,
  ...authRoutes,
  ...TaxRoutes,
  ...errorPagesRoutes,
  ...adminProtectedRoutes,
  ...publicVehicleRoutes,
]

export {
  allRoutes,
  authProtectedRoutes,
  adminProtectedRoutes,
  privateProtectedRoutes,
  brokerProtectedRoutes,
  endUserProtectedRoutes,
  warehouseProtectedRoutes,
  financeireProtectedRoutes,
}

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@components/_loading').default,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
